<template>
  <AlertForm :alert="alert" :onSubmit="submit"></AlertForm>
</template>

<script>
import AlertForm from './Alert-Form.vue';
import { busEvent } from '../../main';

export default {
  name: 'CreateAlert',
  components: {
    AlertForm,
  },
  data: () => ({
    alert: {
      name: '',
      message: '',
    },
  }),
  methods: {
    submit() {
      this.$store.dispatch('alerts/createAlert', this.alert)
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Alerta a fost creata');
          this.$router.push({ path: '/alerts' });
        });
    },
  },
};
</script>
